export interface IDocumentationRestoreUploader {
  GET: (url: string) => Promise<unknown>;
}

export type UploadDocumentationRestore = (
  uploader: IDocumentationRestoreUploader,
  url: string
) => Promise<boolean>;

export const uploadDocumentationRestore: UploadDocumentationRestore =
  async function _uploadDocumentationRestore(
    uploader: IDocumentationRestoreUploader,
    url: string
  ): Promise<boolean> {
    try {
      await uploader.GET(url);
      return true;
    } catch (e) {
      return false;
    }
  };
